import { concat } from '@ember/helper';
/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';
import Component from '@glimmer/component';
import { PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and, eq, not } from 'ember-truth-helpers';

interface HotelMarketInsightDemandLevelIndicatorSignature {
  Args: {
    params?: {
      demandLevelColorScaleNumber: unknown;
      refDateDemandLevelColorScaleNumber: unknown;
    };
  };
}

export default class HotelMarketInsightDemandLevelIndicator extends Component<HotelMarketInsightDemandLevelIndicatorSignature> {
  possibleColorLevels = [1, 2, 3, 4, 5, 6];

  @computed('args.params.demandLevelColorScaleNumber')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get highlightedColorScaleLevel() {
    return this.args.params?.demandLevelColorScaleNumber;
  }

  @computed('args.params.refDateDemandLevelColorScaleNumber')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get highlightedRefDateColorScaleLevel() {
    return this.args.params?.refDateDemandLevelColorScaleNumber;
  }

  <template>
    <div
      class="demand-level-indicator-wrapper flex flex-row
        {{if
          this.highlightedRefDateColorScaleLevel
          'demand-level-indicator-wrapper--with-reference'
        }}"
    >
      {{!
    Generate the 6 demand level blocks
      --> if the tooltip is enabled, we want it to only be for the highlighted block. This is why the extra checks happen here.
  }}
      {{#each this.possibleColorLevels as |colorLevel|}}
        <div
          class="color-level-block-container flex items-center justify-center
            {{if (eq this.highlightedColorScaleLevel colorLevel) 'highlighted'}}
            {{if
              (and
                (not
                  (eq
                    this.highlightedColorScaleLevel
                    this.highlightedRefDateColorScaleLevel
                  )
                )
                (eq this.highlightedRefDateColorScaleLevel colorLevel)
              )
              'reference-highlighted'
            }}"
        >
          <div
            class="color-level-block demand-main-bg-color--level-{{colorLevel}}"
          >
            <PrismTooltip
              @side="top"
              @text={{t (concat "market_insight.rate_level.level" colorLevel)}}
            />
          </div>
        </div>
      {{/each}}
    </div>
  </template>
}
